import React from "react";

export const CoursePreheaderInfo = () => {
  return(
    <div className="preheader-info-container">
      Check the courses that should be activated for all new leagues, events, and trips.
    </div>
  )
}